// extracted by mini-css-extract-plugin
export default {"quadro":"Quadro_quadro__5Gh5B","quadro__title":"Quadro_quadro__title__I7zAH","quadro__text":"Quadro_quadro__text__jExP2"};